
<div class="content-wrapper pt-2"> 
    <section class="content">
      <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header"> Invoice</div> 
        <form [formGroup]="invoiceForm"  autocomplete="off"  class="form-horizontal">   
        <div class="card-body">   
            
          <div class="row">    
            <div class="col-md-3">
              <div class="form-group">
                <label for="invoiceNo" class="col-form-label">Invoice No</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="invoiceNo" class="form-control field-bg-color" [class.is-invalid]="formErrors.invoiceNo" (blur)="logValidationErrors()" placeholder="Invoice No">
                </div>
                <span class="text-danger" *ngIf="formErrors.invoiceNo"><small>{{formErrors.invoiceNo}}</small> </span>   
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="invoiceDate" class="col-form-label">Invoice Date </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="invoiceDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.invoiceDate" (blur)="logValidationErrors()" placeholder="Invoice Date">
                </div>
                <span class="text-danger" *ngIf="formErrors.invoiceDate"><small>{{formErrors.invoiceDate}}</small> </span>   
              </div>
            </div>
            <div class="form-group">
              <input  name="cusId" readonly formControlName="cusId" [(ngModel)]="invoice.cusId" id="cusId"  class="form-control"    type="hidden">
              </div>           
            <div class="col-md-3">
              <div class="form-group">
                <label for="cusName" class="col-form-label">Customer</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" type="text" formControlName="cusName" (focusout)="getCustomerDetails()"  [matAutocomplete]="autoCustomer" class="form-control field-bg-color"  [class.is-invalid]="formErrors.cusName" (blur)="logValidationErrors()" placeholder="Customer Name">
                  <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                    <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.GuestName">
                      {{option.GuestName}}
                    </mat-option>
                  </mat-autocomplete> 
                </div>
                <span class="text-danger" *ngIf="formErrors.cusName"><small>{{formErrors.cusName}}</small> </span>               
              </div>
            </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="address" class="col-form-label">Address</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                    </div>
                    <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="address" placeholder="Address">
                  </div>   
                </div>
              </div> 
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="country" class="col-form-label">Country</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-plane"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="country" placeholder="Country">
                </div>   
              </div>
            </div> 
            <div class="col-md-3">
              <div class="form-group">
                <label for="email" class="col-form-label">Email</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="email" placeholder="Email">
                </div>   
              </div>
            </div> 
            <div class="col-md-3">
              <div class="form-group">
                <label for="phone" class="col-form-label">Phone</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-phone"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="phone" placeholder="Phone">
                </div>   
              </div>
            </div> 
            <div class="col-md-3">
              <div class="form-group">
                <label for="nic" class="col-form-label">NIC</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-drivers-license"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="nic" placeholder="NIC">
                </div>   
              </div>
            </div>    
          </div>
  
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="roomType" class="col-form-label">Room Type</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-institution"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="roomType" placeholder="Room Type">
                </div>   
              </div>
            </div>  
            <div class="col-md-3">
              <div class="form-group">
                <label for="roomNo" class="col-form-label">Room No</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-key"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="roomNo" placeholder="Room No">
                </div>   
              </div>
            </div>  
            <div class="col-md-3">
              <div class="form-group">
                <label for="checkIn" class="col-form-label">checked In </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="checkIn" class="form-control field-bg-color"  placeholder="Checked In">
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="checkOut" class="col-form-label">Checked Out </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="checkOut" class="form-control field-bg-color"  placeholder="Checked Out">
                </div>
              </div>
            </div>
        
          </div>
     

        <div class="row"> 
          <div class="col-md-12">
          <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
            <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
              <tr>
                <th style="width: 15%"  scope="col">Item Code</th>
                <th style="width: 20%"  scope="col">Description</th>
                <th style="width: 15%"  scope="col" style="text-align: center">SalesType</th>
                <th style="width: 10%"  scope="col" style="text-align: center">UnitPrice</th>
                <th style="width: 5%"  scope="col" style="text-align: center">Qty</th>
                <th style="width: 10%"  scope="col" style="text-align: center">Disc</th>
                <th style="width: 10%"  scope="col" style="text-align: center">Comm</th>
                <th style="width: 15%" scope="col" style="text-align: center">Amount</th>
                <th *ngIf="!isHideBtn"></th> 
              </tr>
              </thead>
  
              <tbody class="ml-1" formArrayName="invoiceItems" *ngFor="let invoiceItem of invoiceForm.get('invoiceItems')['controls']; let i = index">                    
                    <tr [formGroupName] = "i" >                      
                      <td><input  (focusout)="getItemData(i)" [matAutocomplete]="auto" [readonly]="isfieldReadOnly" [ngClass]="{'dark-input-field' : isDark }" type="text"  class="form-control form-control-sm field-bg-color" formControlName="itemCode" [class.is-invalid]="invoiceItem.get('itemCode').invalid && invoiceItem.get('itemCode').touched">
                        <mat-autocomplete autoActiveFirstOption   #auto="matAutocomplete">
                          <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option.ItemCode">
                            {{option.ItemCode}}
                          </mat-option>
                        </mat-autocomplete> 
                      </td>   
                                         
                        <td><input [ngClass]="{'dark-input-field' : isDark }" readonly type="text" class="form-control form-control-sm field-bg-color" formControlName="description" [class.is-invalid]="invoiceItem.get('description').invalid && invoiceItem.get('description').touched"></td> 
                        <td><input [ngClass]="{'dark-input-field' : isDark }" readonly type="text" class="form-control form-control-sm field-bg-color" formControlName="salesType"></td>  
                        <td><input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" type="text" (focusout)="calEachItemAmount(i)" (keyup)="calEachItemAmount(i)"  style="text-align: right"   class="form-control form-control-sm field-bg-color" formControlName="unitPrice" allowNumberOnly [class.is-invalid]="invoiceItem.get('unitPrice').invalid && invoiceItem.get('unitPrice').touched"></td>                        
                        <td><input [ngClass]="{'dark-input-field' : isDark }" (focusout)="calEachItemAmount(i)"  (keyup)="calEachItemAmount(i)"   [readonly]="isfieldReadOnly" type="text"  style="text-align: right" allowNumberOnly   class="form-control form-control-sm field-bg-color" formControlName="qty" [class.is-invalid]="invoiceItem.get('qty').invalid && invoiceItem.get('qty').touched"></td>
                        <td><input [ngClass]="{'dark-input-field' : isDark }" (focusout)="calEachItemAmount(i)"  (keyup)="calEachItemAmount(i)"  type="text" style="text-align: right"  [readonly]="isfieldReadOnly" class="form-control form-control-sm field-bg-color" formControlName="discount"></td>  
                        <td><input [ngClass]="{'dark-input-field' : isDark }" (focusout)="calEachItemAmount(i)"  (keyup)="calEachItemAmount(i)"  type="text" style="text-align: right" [readonly]="isfieldReadOnly" class="form-control form-control-sm field-bg-color" formControlName="commission"></td>  
                        <td><input [ngClass]="{'dark-input-field' : isDark }" (focusout)="calEachItemAmount(i)"   type="text" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="amount" [class.is-invalid]="invoiceItem.get('amount').invalid && invoiceItem.get('amount').touched"></td>    
                        <td *ngIf="!isHideBtn">
                          <button *ngIf="!isBtnDisabled && invoiceForm.get('invoiceItems').length > 1" class="btn btn-danger btn-sm ml-1 text-white" (click)="removeItemButtonClick(i)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>         
                      </td>                   
                      </tr>                                                         
              </tbody>
              <tfoot *ngIf="!isHideBtn">
                <tr>
                  <td colspan="8"><button  [disabled]="isBtnDisabled || invoiceForm.get('invoiceItems').invalid" type="button" class="btn btn-success btn-sm text-white float-right" (click)="addItemButtonClick()"><i class="fa fa-plus"></i> Add</button></td>
                </tr>   
              </tfoot>
          </table> 
        </div> 
      </div>

          <div class="row mt-3 mr-4">
            <div class="col-md-4" *ngIf="showInvoicePmtDetails">
              <div class="form-group">
            <table class="table  table-clear table-sm" [ngClass]="{'dark-bg' : isDark }">
            <tbody>
              <tr>
                <td colspan="2" class="text-center pt-2"><strong>Invoice Details</strong></td>                
            </tr> 
             <tr>
                <td  class="pt-2">Status</td>
                <td>{{invoice.status}}</td>
            </tr> 
            <tr>
              <td class="pt-2">Invoice Total</td>
               <td>{{invoice.grandTotal |  number:'1.2-2'}}</td>
            </tr> 
            <tr *ngIf="invoice.advancePaid && invoice.advancePaid !=0">
              <td class="pt-2">Advance Paid</td>
               <td>{{invoice.advancePaid |  number:'1.2-2'}}</td>
            </tr> 
            <tr>
              <td class="pt-2">Paid Amount</td>
               <td>{{invoice.amountPaid |  number:'1.2-2'}}</td>
            </tr> 
            <tr>
              <td class="pt-2">Balance Due</td>
               <td>{{invoice.balToPay |  number:'1.2-2'}}</td>
            </tr> 
            </tbody>
          </table>
              </div>
          </div>
        
            <div class="col-md-4"  [class.offset-md-4]='bsClassToShow' [class.offset-md-8]='!bsClassToShow'>
              <table class="table table-clear" [ngClass]="{'dark-bg' : isDark }">
                <tbody>
              <tr class="row">
                <td class="left col-sm-4">
                <strong>Total Qty</strong>
                </td>  
                <td class="col-sm-3"></td>             
                <td class="text-right col-sm-5">
                <strong>{{invoice.totalQty | number:'1.2-2'}}</strong>
                </td>
                </tr>
                <tr class="row">
                  <td class="left col-sm-4">
                  <strong>Total Disc</strong>
                  </td>  
                  <td class="col-sm-3"></td>             
                  <td class="text-right col-sm-5">
                  <strong>{{invoice.totalDiscount | number:'1.2-2'}}</strong>
                  </td>
                  </tr>

                  <tr class="row">
                    <td class="left col-sm-5">
                    <strong>Total Comm</strong>
                    </td>  
                    <td class="col-sm-2"></td>             
                    <td class="text-right col-sm-5">
                    <strong>{{invoice.totalComm | number:'1.2-2'}}</strong>
                    </td>
                    </tr>

                <tr class="row">
                <td class="left col-sm-4">
                <strong>Total</strong>
                </td>  
                <td class="col-sm-3"></td>             
                <td class="text-right col-sm-5">
                <strong>{{invoice.grandTotal | number:'1.2-2'}}</strong>
                </td>
                </tr>
                <tr class="row">
                  <td class="left col-sm-5">
                    <strong>AdvancePaid</strong>
                  </td>
                  <td class="col-sm-1"></td>           
                  <td class="col-sm-6"><input [ngClass]="{'dark-bg' : isDark }"  [readonly]="isBtnDisabled" style="text-align: right" [(ngModel)]="invoice.advancePaid" (keyup)="updateBillTotal()" (focusout)="receivedFieldFocusOut()" [ngModelOptions]="{standalone: true}" class="form-control form-control-sm field-bg-color"></td>
                  </tr>
                <tr class="row">
                  <td class="left col-sm-4">
                    <mat-checkbox  [(ngModel)]="selectChkBox" [ngModelOptions]="{standalone: true}" [disabled]="isBtnDisabled" (change)="selectReceivedAmountCheckBoxChange($event)"><strong>Paid</strong></mat-checkbox>                     
                  </td>  
                  <td class="col-sm-2"></td>           
                  <td class="col-sm-6"><input [ngClass]="{'dark-bg' : isDark }" [readonly]="isfieldReceivedReadOnly" style="text-align: right" [(ngModel)]="invoice.amountPaid" (keyup)="updateBillTotal()" (focusout)="receivedFieldFocusOut()" [ngModelOptions]="{standalone: true}" class="form-control form-control-sm field-bg-color"></td>
                  </tr>
                  <tr class="row" *ngIf="isPaidChecked">
                    <td class="left col-sm-4">
                    <strong>Pmt Type</strong>
                    </td>             
                    <td class="text-right col-sm-8">
                      <select  [ngClass]="{'dark-input-field' : isDark }" [(ngModel)]="paymentType" [ngModelOptions]="{standalone: true}" class="form-control field-bg-color">        
                        <option [ngValue]="null">-Select-</option>
                        <option *ngFor="let item of PMT_TYPE" [value]="item.value">
                          {{item.value}}
                        </option>
                    </select>
                    </td>
                    </tr> 
                    <tr class="row" *ngIf="isPaidChecked">
                      <td class="left col-sm-4">
                      <strong>Dep. A/C</strong>
                      </td>           
                      <td class="text-right col-sm-8">
                        <select  [ngClass]="{'dark-input-field' : isDark }" [(ngModel)]="depositAccount" [ngModelOptions]="{standalone: true}" class="form-control field-bg-color">        
                          <option [ngValue]="null">-Select-</option>
                          <option *ngFor="let item of bankAccountList" [value]="item.AccountName">
                            {{item.AccountName}}
                          </option>
                      </select>
                      </td>
                      </tr> 
                  <tr class="row">
                    <td class="left col-sm-5">
                    <strong>Balance Due</strong>
                    </td>
                    <td class="col-sm-2"></td>                
                    <td class="text-right col-sm-5">
                    <strong>{{invoice.balToPay | number:'1.2-2'}}</strong>
                    </td>
                    </tr> 
                </tbody>
                </table>              
                  <input  readonly  [(ngModel)]="receiptNo" [ngModelOptions]="{standalone: true}" class="form-control"   type="hidden">
          </div>
        </div>
  
      
        </div>
        
        <!-- /.card-body -->
          
        <div class="card-footer">
        <button type="button" *ngIf="crud_access.create" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
          <button type="button" *ngIf="crud_access.create" [disabled]="isBtnDisabled"  (click)="saveButtonClick()" class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
          <button  *ngIf="crud_access.delete" class="btn btn-danger ml-2" [disabled]="isCancelBtnDisabled" (click)="deleteButtonClick()">Cancel</button>
          <button class="btn btn-success ml-2" routerLink="../invoice-list">Back to List</button>
          <button  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>
          <button  *ngIf ="crud_access.createReceipt && isShowPayBtn" class="btn btn-success ml-2" (click)="payButtonClicked()"><i class="fa fa-sign-out-alt p-1"></i>Pay</button>
          <button  *ngIf="crud_access.create && !isBtnDisabled"    (click)="loadPurchaseItemsButtonClick()"   mat-raised-button color="accent" class="ml-2">Load Purchase Items</button>

         
          
          <button *ngIf="showPrintButtons" (click)="savePDF('print')"  mat-icon-button class="text-info float-right">
            <mat-icon>print</mat-icon>
          </button>
          <button *ngIf="showPrintButtons" (click)="savePDF('download')"  mat-icon-button class="text-success float-right">
            <mat-icon>cloud_download</mat-icon>
          </button>
          <button *ngIf="showPrintButtons" (click)="savePDF('open')"  mat-icon-button class="text-dark float-right">
            <mat-icon [ngClass]="{'dark-bg' : isDark }">preview</mat-icon>
          </button>
        
        </div>

        </form>
      </div>
  
    </section>

  </div> 

    <!-- Form Values : {{ invoiceForm.value | json }}   -->



  
